import * as THREE from "three";
import { insulatedSprite } from "./assets/materials";
export class Sprites {
    constructor(scene) {
        if (scene.formData.insulatedPanel === true) {
            this.createSprites(scene);
        }
    }
    createSprites(scene) {
        const material = new THREE.SpriteMaterial({
            color: 0xFFFFFF,
            map: insulatedSprite
        });
        material.map.minFilter = THREE.LinearFilter;
        const sprite = new THREE.Sprite(material);
        sprite.scale.set(200, 200, 200);
        sprite.position.copy(scene.dimensions.centerPos);
        sprite.position.y = 260;
        scene.threeScene.add(sprite);
    }
}
